export const MostSearched = [
    {
        data: 'air force',
        value: 'air force'
    },
    {
        data: 'jordan',
        value: 'jordan'
    },
    {
        data: 'puma suede',
        value: 'puma suede'
    },
    {
        data: 'buty nike',
        value: 'buty nike'
    },
    {
        data: 'buty adidas',
        value: 'buty adidas'
    },
    {
        data: 'guess',
        value: 'guess'
    },
    {
        data: 'adidas originals',
        value: 'adidas originals'
    },
    {
        data: 'asics',
        value: 'asics'
    },
    {
        data: 'bluza adidas',
        value: 'bluza adidas'
    },
    {
        data: 'bluza nike',
        value: 'bluza nike'
    },
];

